import React, { useCallback, useContext } from 'react';
import PropTypes from 'prop-types';
import MountedProvider from '../MountedProvider';
var Context = React.createContext(function () {
  return Date.now();
});
/**
 * A context provider for accessing the current time while ensuring that the
 * initial client-side render uses the same time as the server. For this to
 * work, you must pass the `initialNow` prop.
 *
 * The context value is a function that can be called to get the current time.
 */

export default function RenderTime(_ref) {
  var children = _ref.children,
      initialNow = _ref.initialNow,
      now = _ref.now;
  var mounted = useContext(MountedProvider.Context);
  var getTime = useCallback(function () {
    return mounted || initialNow == null ? now() : initialNow;
  }, [mounted, initialNow, now]);
  return React.createElement(Context.Provider, {
    value: getTime
  }, children);
}
RenderTime.propTypes = {
  children: PropTypes.node,
  initialNow: PropTypes.number,
  now: PropTypes.func.isRequired
};
RenderTime.defaultProps = {};
RenderTime.Context = Context;